/**
 * @generated SignedSource<<57ba24337c4d2be970a0df2a5ea484d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleCarouselVariant_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarousel_user">;
  readonly " $fragmentType": "HpSharedFeaturedModuleCarouselVariant_user";
};
export type HpSharedFeaturedModuleCarouselVariant_user$key = {
  readonly " $data"?: HpSharedFeaturedModuleCarouselVariant_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarouselVariant_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleCarouselVariant_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5be266b0cc4166d0c69d72d5d26f3f5d";

export default node;
